import React, { useEffect, useState } from 'react';

import { contentfulClient } from '../config/contentful.ts';
import { BlogPost } from '../types/contentful.ts';

const Blog: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await contentfulClient.getEntries();
        setPosts(response.items as BlogPost[]);
      } catch (err) {
        setError('Failed to fetch blog posts');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (error) return <div className="text-center py-5 text-danger">{error}</div>;

  return (
    <div className="container-fluid program py-5">
      <div className="container py-5">
        <div className="mx-auto text-center wow fadeIn" data-wow-delay="0.1s" style={{ maxWidth: '700px' }}>
          <h4 className="text-primary mb-4 border-bottom border-primary border-2 d-inline-block p-2 title-border-radius">Tin Tức & Sự Kiện</h4>
        </div>
        <div className="row g-5 justify-content-center">
          {posts.map((post) => (
          <div key={post.sys.id} className="col-md-6 col-lg-6 col-xl-4 wow fadeIn" data-wow-delay="0.3s">
            <div className="program-item rounded">
                <div className="program-img position-relative">
                <div className="overflow-hidden img-border-radius">
                    <Image assetId={post.fields.image.sys.id} />
                </div>
                </div>
                <div className="program-text bg-white px-4 pb-3">
                <div className="program-text-inner">
                    <a href={`/blog/${post.sys.id}`} className="h4">{post.fields.title}</a>
                </div>
                </div>
            </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Image: React.FC<{ assetId: string }> = ({ assetId }) => {
    const [image, setImage] = useState<string | null>(null);

    useEffect(() => {
        const fetchImage = async () => {
            const response = await contentfulClient.getAsset(assetId);
            setImage(response.fields.file.url);
        };
        fetchImage();
    }, [assetId]);

    return <img src={image} className="img-fluid w-100" alt="Pre-CK Class" />;
};

export default Blog; 